// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/payment/v1/order.proto (package gportal.api.payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Region } from "../../../type/v1/region_pb.js";
import { Money } from "../../../type/v1/money_pb.js";

/**
 * Type of unit measurement for gamecloud services.
 *
 * @generated from enum gportal.api.payment.v1.UnitType
 */
export enum UnitType {
  /**
   * @generated from enum value: UNIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNIT_TYPE_SLOT = 1;
   */
  SLOT = 1,

  /**
   * @generated from enum value: UNIT_TYPE_GB = 2;
   */
  GB = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(UnitType)
proto3.util.setEnumType(UnitType, "gportal.api.payment.v1.UnitType", [
  { no: 0, name: "UNIT_TYPE_UNSPECIFIED" },
  { no: 1, name: "UNIT_TYPE_SLOT" },
  { no: 2, name: "UNIT_TYPE_GB" },
]);

/**
 * Processing status of a checkout. Reported by GetCheckoutStatus once
 * SubmitCheckout has finished — `PROCESSING` covers the time between the
 * Chargebee subscription being created and the asynchronous webhook +
 * downstream provisioning chain (Gamecloud server deploy, Loot-Pass
 * activation, etc.) finishing. `PROCESSED` is only emitted once both the
 * subscription is `active` AND any product-specific provisioning has
 * completed, so the redirect URL can be safely followed.
 *
 * @generated from enum gportal.api.payment.v1.CheckoutStatus
 */
export enum CheckoutStatus {
  /**
   * @generated from enum value: CHECKOUT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECKOUT_STATUS_PROCESSING = 1;
   */
  PROCESSING = 1,

  /**
   * @generated from enum value: CHECKOUT_STATUS_PROCESSED = 2;
   */
  PROCESSED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CheckoutStatus)
proto3.util.setEnumType(CheckoutStatus, "gportal.api.payment.v1.CheckoutStatus", [
  { no: 0, name: "CHECKOUT_STATUS_UNSPECIFIED" },
  { no: 1, name: "CHECKOUT_STATUS_PROCESSING" },
  { no: 2, name: "CHECKOUT_STATUS_PROCESSED" },
]);

/**
 * Payment source type, mirroring Chargebee's `payment_source.type` enum.
 * Add new values as Chargebee introduces them; new enum entries are
 * non-breaking in proto3. Used by SetupPaymentMethodResponse (legacy
 * add-payment-method flow); the new Payment Components flow exposes type
 * as a plain string instead so new chargebee method types don't require
 * a proto change.
 *
 * @generated from enum gportal.api.payment.v1.PaymentSourceType
 */
export enum PaymentSourceType {
  /**
   * @generated from enum value: PAYMENT_SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_SOURCE_TYPE_CARD = 1;
   */
  CARD = 1,

  /**
   * @generated from enum value: PAYMENT_SOURCE_TYPE_PAYPAL_EXPRESS_CHECKOUT = 2;
   */
  PAYPAL_EXPRESS_CHECKOUT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentSourceType)
proto3.util.setEnumType(PaymentSourceType, "gportal.api.payment.v1.PaymentSourceType", [
  { no: 0, name: "PAYMENT_SOURCE_TYPE_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_SOURCE_TYPE_CARD" },
  { no: 2, name: "PAYMENT_SOURCE_TYPE_PAYPAL_EXPRESS_CHECKOUT" },
]);

/**
 * Kind of a CheckoutLineItem, mirroring Chargebee's item `type` (and the
 * Payment Components line-item type). Only used by the deprecated
 * CreateCheckoutPaymentIntentResponse.line_items, which is not populated.
 *
 * @generated from enum gportal.api.payment.v1.CheckoutLineItemType
 */
export enum CheckoutLineItemType {
  /**
   * @generated from enum value: CHECKOUT_LINE_ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECKOUT_LINE_ITEM_TYPE_PLAN = 1;
   */
  PLAN = 1,

  /**
   * @generated from enum value: CHECKOUT_LINE_ITEM_TYPE_ADDON = 2;
   */
  ADDON = 2,

  /**
   * @generated from enum value: CHECKOUT_LINE_ITEM_TYPE_CHARGE = 3;
   */
  CHARGE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CheckoutLineItemType)
proto3.util.setEnumType(CheckoutLineItemType, "gportal.api.payment.v1.CheckoutLineItemType", [
  { no: 0, name: "CHECKOUT_LINE_ITEM_TYPE_UNSPECIFIED" },
  { no: 1, name: "CHECKOUT_LINE_ITEM_TYPE_PLAN" },
  { no: 2, name: "CHECKOUT_LINE_ITEM_TYPE_ADDON" },
  { no: 3, name: "CHECKOUT_LINE_ITEM_TYPE_CHARGE" },
]);

/**
 * Available unit configuration for a product at a given location and duration.
 *
 * @generated from message gportal.api.payment.v1.Units
 */
export class Units extends Message<Units> {
  /**
   * @generated from field: gportal.api.payment.v1.UnitType type = 1;
   */
  type = UnitType.UNSPECIFIED;

  /**
   * Available values, e.g. [4, 8, 16, 32, 64]
   *
   * @generated from field: repeated int32 values = 2;
   */
  values: number[] = [];

  /**
   * Default/recommended value
   *
   * @generated from field: optional int32 default = 3;
   */
  default?: number;

  /**
   * Maps 1 Chargebee unit to N game units (from PlanMetadataGamecloud)
   *
   * @generated from field: optional double multiplier = 4;
   */
  multiplier?: number;

  /**
   * Game-specific minimum units (from PlanMetadataGamecloud)
   *
   * @generated from field: optional int32 min_units = 5;
   */
  minUnits?: number;

  /**
   * Game-specific maximum units (from PlanMetadataGamecloud)
   *
   * @generated from field: optional int32 max_units = 6;
   */
  maxUnits?: number;

  /**
   * Server infrastructure maximum (from WI MaxSlots)
   *
   * @generated from field: optional int32 max_server_units = 7;
   */
  maxServerUnits?: number;

  constructor(data?: PartialMessage<Units>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.Units";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UnitType) },
    { no: 2, name: "values", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "default", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "multiplier", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "min_units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "max_units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "max_server_units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Units {
    return new Units().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Units {
    return new Units().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Units {
    return new Units().fromJsonString(jsonString, options);
  }

  static equals(a: Units | PlainMessage<Units> | undefined, b: Units | PlainMessage<Units> | undefined): boolean {
    return proto3.util.equals(Units, a, b);
  }
}

/**
 * A server location available for a product.
 *
 * @generated from message gportal.api.payment.v1.OrderLocation
 */
export class OrderLocation extends Message<OrderLocation> {
  /**
   * Maps to infrastructure location_key
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Display name (e.g. "Frankfurt")
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Country code (e.g. "DE")
   *
   * @generated from field: string country = 3;
   */
  country = "";

  /**
   * True if not sold out
   *
   * @generated from field: bool available = 4;
   */
  available = false;

  /**
   * URL for client-side latency testing
   *
   * @generated from field: string latency_endpoint_url = 5;
   */
  latencyEndpointUrl = "";

  /**
   * Region this location belongs to (EUR or INT)
   *
   * @generated from field: gportal.type.v1.Region region = 6;
   */
  region = Region.UNSPECIFIED;

  /**
   * WI-allowed currencies for this location
   *
   * @generated from field: repeated string currencies = 7;
   */
  currencies: string[] = [];

  constructor(data?: PartialMessage<OrderLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.OrderLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "latency_endpoint_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 7, name: "currencies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderLocation {
    return new OrderLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderLocation {
    return new OrderLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderLocation {
    return new OrderLocation().fromJsonString(jsonString, options);
  }

  static equals(a: OrderLocation | PlainMessage<OrderLocation> | undefined, b: OrderLocation | PlainMessage<OrderLocation> | undefined): boolean {
    return proto3.util.equals(OrderLocation, a, b);
  }
}

/**
 * An addon available for a product.
 *
 * @generated from message gportal.api.payment.v1.Addon
 */
export class Addon extends Message<Addon> {
  /**
   * Chargebee addon ID
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Display name
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Short description
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * Price in request currency
   *
   * @generated from field: gportal.type.v1.Money price = 4;
   */
  price?: Money;

  /**
   * Whether addon should be pre-selected in UI
   *
   * @generated from field: bool selected_by_default = 5;
   */
  selectedByDefault = false;

  /**
   * Chargebee pricing model: "flat_fee", "per_unit", "tiered", etc.
   *
   * @generated from field: string pricing_model = 6;
   */
  pricingModel = "";

  /**
   * Units of this addon the customer holds (active_addons only, TV-1711). Unset/flat_fee defaults to 1.
   *
   * @generated from field: optional int32 quantity = 7;
   */
  quantity?: number;

  constructor(data?: PartialMessage<Addon>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.Addon";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price", kind: "message", T: Money },
    { no: 5, name: "selected_by_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "pricing_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Addon {
    return new Addon().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Addon {
    return new Addon().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Addon {
    return new Addon().fromJsonString(jsonString, options);
  }

  static equals(a: Addon | PlainMessage<Addon> | undefined, b: Addon | PlainMessage<Addon> | undefined): boolean {
    return proto3.util.equals(Addon, a, b);
  }
}

/**
 * An addon selected by the user with an optional quantity override.
 *
 * @generated from message gportal.api.payment.v1.AddonSelection
 */
export class AddonSelection extends Message<AddonSelection> {
  /**
   * Chargebee addon parent item ID (e.g. "Gameclouds-Modspace-25GB"). The handler resolves the correct item price ID from the pricing cache based on the subscription's currency and billing period.
   *
   * @generated from field: string addon_id = 1;
   */
  addonId = "";

  /**
   * Quantity for this addon. If unset or flat_fee pricing model, defaults to 1.
   *
   * @generated from field: optional int32 quantity = 2;
   */
  quantity?: number;

  /**
   * TV-1833: per-addon renewal intent for multi-addon reactivate. Unset = legacy behavior (a kept
   * addon that is pending end-of-term removal is reactivated). true = keep this addon scheduled for
   * end-of-term removal (do NOT reactivate it) while a sibling is reactivated in the same request.
   * Field PRESENCE is the "intent-aware request" signal: the handler routes per-addon reactivate
   * only when this field is set on the request, otherwise it keeps the legacy multi-pending refusal.
   *
   * @generated from field: optional bool cancel_at_end_of_term = 3;
   */
  cancelAtEndOfTerm?: boolean;

  constructor(data?: PartialMessage<AddonSelection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AddonSelection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "addon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "cancel_at_end_of_term", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddonSelection {
    return new AddonSelection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddonSelection {
    return new AddonSelection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddonSelection {
    return new AddonSelection().fromJsonString(jsonString, options);
  }

  static equals(a: AddonSelection | PlainMessage<AddonSelection> | undefined, b: AddonSelection | PlainMessage<AddonSelection> | undefined): boolean {
    return proto3.util.equals(AddonSelection, a, b);
  }
}

/**
 * A single order line, in the payment component's `context.cart.lineItems`
 * shape. Only used by the deprecated
 * CreateCheckoutPaymentIntentResponse.line_items, which is not populated.
 *
 * @generated from message gportal.api.payment.v1.CheckoutLineItem
 */
export class CheckoutLineItem extends Message<CheckoutLineItem> {
  /**
   * Chargebee id of the line: the item price id for the plan line (which
   * chargebee.js reads as planItemPriceId), the item id for an addon, a fixed
   * id for the discount line.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Kind of line (plan / addon / charge).
   *
   * @generated from field: gportal.api.payment.v1.CheckoutLineItemType type = 2;
   */
  type = CheckoutLineItemType.UNSPECIFIED;

  /**
   * Human-readable label (plan/addon external name).
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * Total line amount in minor units, tax inclusive. The lines sum to the
   * payment_intent total (a discount line reconciles coupons).
   *
   * @generated from field: int64 amount = 4;
   */
  amount = protoInt64.zero;

  constructor(data?: PartialMessage<CheckoutLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CheckoutLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(CheckoutLineItemType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutLineItem {
    return new CheckoutLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutLineItem {
    return new CheckoutLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutLineItem {
    return new CheckoutLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutLineItem | PlainMessage<CheckoutLineItem> | undefined, b: CheckoutLineItem | PlainMessage<CheckoutLineItem> | undefined): boolean {
    return proto3.util.equals(CheckoutLineItem, a, b);
  }
}

/**
 * The customer's billing details, prefilled into the chargebee.components
 * `context.billingAddress` (and `context.customer` for the email/name, which
 * the method forms read from the customer rather than the address).
 * Alternative methods (Klarna, Alipay, ...) render a billing-address form;
 * prefilling it from the data
 * we already hold (WI customer details) spares the buyer re-entering it. Only
 * fields we actually have on file are populated — the rest come back empty and
 * the buyer completes them. Card / PayPal don't render this form and ignore it.
 *
 * @generated from message gportal.api.payment.v1.CheckoutBillingAddress
 */
export class CheckoutBillingAddress extends Message<CheckoutBillingAddress> {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName = "";

  /**
   * @generated from field: string last_name = 2;
   */
  lastName = "";

  /**
   * Carried on `context.customer.email`, where the method forms read it.
   *
   * @generated from field: string email = 3;
   */
  email = "";

  /**
   * Street + house number (WI `street`). Frequently blank for accounts that
   * never completed an address; left to the buyer to fill in that case.
   *
   * @generated from field: string address_line1 = 5;
   */
  addressLine1 = "";

  /**
   * @generated from field: string city = 6;
   */
  city = "";

  /**
   * @generated from field: string state = 7;
   */
  state = "";

  /**
   * @generated from field: string zip = 8;
   */
  zip = "";

  /**
   * ISO 3166-1 alpha-2 country. Method eligibility reads it: Klarna, for one,
   * is only offered with a billing country.
   *
   * @generated from field: string country_code = 9;
   */
  countryCode = "";

  constructor(data?: PartialMessage<CheckoutBillingAddress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CheckoutBillingAddress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "address_line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutBillingAddress {
    return new CheckoutBillingAddress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutBillingAddress {
    return new CheckoutBillingAddress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutBillingAddress {
    return new CheckoutBillingAddress().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutBillingAddress | PlainMessage<CheckoutBillingAddress> | undefined, b: CheckoutBillingAddress | PlainMessage<CheckoutBillingAddress> | undefined): boolean {
    return proto3.util.equals(CheckoutBillingAddress, a, b);
  }
}

